export enum WREX_EMBEDDED_VIDEO {
    /**
     * @value Attach video
     * @description The tooltip displayed on the video attachment button in posts and comments editors.
     */
    ATTACH_VIDEO_BUTTON_TOOLTIP = 'WREX_ATTACHMENTS.VIDEO_BUTTON_TOOLTIP',
    /**
     * @value Enter video URL
     * @description Text used for example to label a button inviting the user to enter the url of a video (youtube, dailymotion etc...) in order to integrate it in a post.
     */
    ENTER_URL = 'FRONT.ENTER_VIDEO_URL',
    /**
     * @value Insert video
     * @description The tooltip displayed on the video insertion button, within a rich editor's toolbar.
     */
    INSERTION_BUTTON_TOOLTIP = 'WREX_EMBEDDED_VIDEO.BUTTON_TOOLTIP',
}
